import React, {useState} from 'react';
import MailIcon from "../Images/feather-mail.svg";
import CloseFillBlackBtn from "../Images/close-circle-black-filled.svg";
import './ContactBtn.css';


const ContactBtn = () => {
    const [showModal, setShowModal] = useState(false);
    return (
        <>
            <div className="group p-3 flex justify-between
                        hover:w-36 cursor-pointer
                        rounded-2xl fixed bottom-12 right-8
                        transition-all duration-700 ease-in-out
                        bg-gradient-to-b from-[#F8CED5_20%] to-[#68CBF1_80%]
                        hover:bg-gradient-to-r hover:from-[#68CBF1_45%] hover:to-[#F8CED5_90%]"
                 onClick={() => setShowModal(true)}
            >
                <div
                    className="hidden transition-all duration-700 ease-in-out group-hover:block font-semibold pr-1">Contáctanos
                </div>
                <img className="w-6" src={MailIcon} alt="logo"/>
            </div>

            {showModal ? (
                <>
                    <div
                        className="flex overflow-hidden fixed inset-0 z-[902] outline-none focus:outline-none"
                    >
                        <div className="relative w-auto mx-auto md:max-w-5xl bg-white overflow-scroll">
                            <div className="flex flex-col place-items-end p-8"
                                 onClick={() => setShowModal(false)}
                            >
                                <img className="w-8 cursor-pointer" src={CloseFillBlackBtn} alt="logo"/>
                            </div>
                            <div
                                className="border-0 shadow-lg relative flex flex-col grid md:grid-cols-2 w-full outline-none pb-32">
                                <div className="md:my-36 mb-4 px-8 md:px-12">
                                    <h1 className="text-2xl pb-4 md:text-5xl md:pb-8">¡Llamado a los estilistas!</h1>
                                    <div className="md:text-xl md:leading-9">
                                        <p>
                                            ¿Estás interesado o interesada en que tu salón forme parte de
                                            Transformation?
                                        </p>
                                        <p>
                                            Déjanos tu información y pronto te estaremos contactando.
                                        </p>
                                    </div>
                                </div>
                                <div className="md:pr-8">
                                    <div className="flex flex-col text-end mx-8">
                                        <form className="space-y-5 md:space-y-7 js-cm-form"
                                              action="https://www.createsend.com/t/subscribeerror?description="
                                              method="post"
                                              id="subForm"
                                              data-id="2BE4EF332AA2E32596E38B640E905619DDE485629A58C0D7AD0BE170C8C2FCEAD3AC02B783DE91E6393464178C64AE8DF277E421705524B73BB7BAF0A44A0AA0"
                                        >
                                            <p>(*) Campos Obligatorios</p>
                                            <input className="border border-black w-full md:h-14 h-10 pl-4" type="text"
                                                   id="fieldName" name="cm-name" placeholder="Nombre*" required/>
                                            <input className="border border-black w-full md:h-14 h-10 pl-4 js-cm-email-input qa-input-email" type="email"
                                                   placeholder="Email*" id="fieldEmail" name="cm-jihiukj-jihiukj" required/>
                                            <input className="border border-black w-full md:h-14 h-10 pl-4"
                                                   type="number" id="fieldtjlytyt" name="cm-f-tjlytyt"
                                                   placeholder="Telefono*" required/>
                                            <input
                                                id="fieldttmduj"
                                                name="cm-f-ttmduj"
                                                type="date"
                                                placeholder="Fecha de Nacimiento"
                                                className="border border-black ml-0 flex md:h-14 h-10 px-4 inputEStilistas"
                                                required="true"
                                            />
                                            <input className="border border-black w-full md:h-14 h-10 pl-4" type="text"
                                                   id="fieldtjlytyi" name="cm-f-tjlytyi" placeholder="Direccion*" required/>
                                            <textarea className="border border-black w-full p-4 md:h-32 h-28"
                                                      id="fieldtjlytyd" name="cm-f-tjlytyd" placeholder="Comentarios"></textarea>
                                            <div className="mt-2 flex text-left font-bold m-auto">
                                                <div>
                                                    <input
                                                        style={{accentColor: 'black'}}
                                                        type="checkbox"
                                                        required="true"
                                                        id="cm-privacy-consent"
                                                        name="cm-privacy-consent"
                                                    />
                                                </div>
                                                <div className="pl-2 mb-2 text-[10px] md:text-[13px]">
                                                    Al enviar este formulario, confirmo que soy residente de Puerto Rico 18+ y acepto los <a
                                                    href="/transformation/terms-and-conditions" className="border-b border-black" target="_blank">Términos de
                                                    uso</a>, <a href="/transformation/privacy-policy" className="border-b border-black" target="_blank">Políticas de
                                                    Privacidad</a> y recibir comunicaciones de marketing y promocionales de L’Óreal
                                                    Caribe; (2) He leído y reconozco la Política de privacidad y Términos y Condiciones de
                                                    Transformation por L’Óreal Caribe. L’Óreal Caribe utiliza la información personal que recopila y
                                                    procesa para proporcionarle contenido, anuncios, ofertas y otras comunicaciones promocionales y
                                                    de marketing personalizadas (incluidos correos electrónicos promocionales) de Transformation y
                                                    sus otras marcas, incluso basadas en su perfil de belleza, y para otros fines enumerados en la
                                                    Política de privacidad de L’Óreal Caribe.
                                                </div>
                                            </div>
                                            <div className="flex justify-center">
                                                <button type="submit"
                                                        className="bg-black text-white w-60 px-8 h-14 font-bold">Contáctenme
                                                    Pronto
                                                </button>
                                            </div>
                                        </form>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </>
    );
};


export default ContactBtn;
